var React = require('react');

function ArrowDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 1L6.5 7L1 1","stroke":"#07055B"}));
}

ArrowDownInline.defaultProps = {"width":"13","height":"8","viewBox":"0 0 13 8","fill":"none"};

module.exports = ArrowDownInline;

ArrowDownInline.default = ArrowDownInline;
